import api from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: null,
  permissions: [],
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // 用户登录
  async login ({ commit }, userInfo) {
    const response = await api.login(userInfo)
    const { access_token, refresh_token } = response

    commit('SET_TOKEN', access_token)
    setToken(access_token)

    // 存储刷新令牌
    localStorage.setItem('refresh_token', refresh_token)

    return response
  },

  // 获取用户信息
  async getUserInfo ({ commit, state }) {
    const response = await api.getUserInfo()
    const userInfo = response

    commit('SET_USER_INFO', userInfo)
    commit('SET_ROLES', [userInfo.role])

    // 根据角色设置权限
    const permissions = getPermissionsByRole(userInfo.role)
    commit('SET_PERMISSIONS', permissions)

    return userInfo
  },

  // 用户登出
  async logout ({ commit }) {
    try {
      await api.logout()
    } catch (error) {
      console.error('登出失败:', error)
    } finally {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', null)
      commit('SET_PERMISSIONS', [])
      commit('SET_ROLES', [])
      removeToken()
      localStorage.removeItem('refresh_token')
    }
  },

  // 刷新令牌
  async refreshToken ({ commit, state }) {
    const refreshToken = localStorage.getItem('refresh_token')
    if (!refreshToken) {
      throw new Error('刷新令牌不存在')
    }

    const response = await api.refreshToken(refreshToken)
    const { access_token } = response

    commit('SET_TOKEN', access_token)
    setToken(access_token)

    return access_token
  },

  // 更新用户信息
  async updateUserInfo ({ commit }, userInfo) {
    const response = await api.updateUserInfo(userInfo)
    commit('SET_USER_INFO', response)
    return response
  },

  // 修改密码
  async changePassword ({ commit }, passwordInfo) {
    const response = await api.changePassword(passwordInfo)
    return response
  }
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  permissions: state => state.permissions,
  roles: state => state.roles,
  isAuthenticated: state => !!state.token,
  role: state => state.userInfo?.role || '',
  username: state => state.userInfo?.username || '',
  realName: state => state.userInfo?.real_name || ''
}

// 根据角色获取权限
function getPermissionsByRole (role) {
  const permissionsMap = {
    admin: ['*'],
    hr: [
      'recruitment:view',
      'recruitment:create',
      'recruitment:edit',
      'recruitment:delete',
      'candidate:view',
      'candidate:create',
      'candidate:edit',
      'candidate:delete',
      'interview:view',
      'interview:create',
      'interview:edit',
      'department:view',
      'offer:create',
      'offer:edit',
      'offer:accept',
      'offer:reject',
      'offer:delete'
    ],
    manager: [
      'recruitment:view',
      'recruitment:create',
      'recruitment:edit',
      'department:view',
      'candidate:view',
      'interview:view',
      'interview:create',
      'interview:edit',
      'offer:create',
      'offer:reject'
    ],
    interviewer: [
      'interview:view',
      'interview:create',
      'interview:edit',
      'candidate:view'
    ],
    employee: [
      'recruitment:view'
    ]
  }

  return permissionsMap[role] || []
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
